<template>
<div>
  <el-button type="success"
             @click="resetCompanies();$modal.show('job-dialog');">
    自動入力
  </el-button>
  <modal name="job-dialog"
         :adaptive="true"
         :scrollable="true"
         height="auto">
    <div class="v--modal-close-top">
      <el-button @click="$modal.hide('job-dialog');"
                 icon="el-icon-close"
                 type="text"></el-button>
    </div>
    <div class="title">職歴自動入力</div>
    <p>会社名と在籍期間を元に、入社・退社表記を自動で作成します。</p>
    <p>&nbsp;</p>
    <div class="edit-form">
      <div class="edit-form-item">
        <div class="item-name">会社名</div>
        <div class="item-body">
          <el-input class="input-md"
                    placeholder="会社名を入力"
                    title="会社名"
                    v-model="company.name"
                    @keyup.native.enter="$formLib.nextInput($refs.startYear)"
                    ref="companyName"></el-input>
        </div>
      </div>
      <div class="edit-form-item">
        <div class="item-name">在籍期間</div>
        <div class="item-body job-auto-input-period">
          <div class="period-start">
            <el-input class="input-xxs"
                      placeholder="2000"
                      title="年"
                      v-model="company.startYear"
                      type="number"
                      :min="calcMinYear"
                      :max="calcMaxYear"
                      :maxlength="4"
                      @keyup.native.enter="$formLib.nextInput($refs.startMonth)"
                      ref="startYear"></el-input><span>年</span>
            <el-input class="input-xxs input-2-digit"
                      placeholder="1"
                      title="月"
                      v-model="company.startMonth"
                      type="number"
                      min="1"
                      max="12"
                      @keyup.native.enter="$formLib.nextInput($refs.endYear)"
                      ref="startMonth">
            </el-input><span>月から</span>
          </div>
          <div class="period-end">
            <el-input class="input-xxs"
                      placeholder="2018"
                      title="年"
                      v-model="company.endYear"
                      :min="calcMinYear"
                      :max="calcMaxYear"
                      type="number"
                      ref="endYear"
                      @keyup.native.enter="$formLib.nextInput($refs.endMonth)"
                      :disabled="isContinuing"></el-input><span>年</span>
            <el-input class="input-xxs input-2-digit"
                      placeholder="12"
                      title="月"
                      v-model="company.endMonth"
                      type="number"
                      min="1"
                      max="12"
                      ref="endMonth"
                      :disabled="isContinuing">
            </el-input><span>月まで</span>
            <div class="tenure">
              <el-checkbox v-model="isContinuing">現在も勤務中</el-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="edit-form-item"
           v-if="!isContinuing">
        <div class="item-name">退職理由</div>
        <div class="item-body">
          <div class="radio-horizontal">
            <el-radio v-model="retirementReason"
                      label="">記載しない</el-radio>
            <el-radio v-model="retirementReason"
                      label="一身上の都合により">一身上の都合により</el-radio>
            <el-radio v-model="retirementReason"
                      label="会社都合により">会社都合により</el-radio>
            <el-radio v-model="retirementReason"
                      label="契約期間満了のため">契約期間満了のため</el-radio>
            <el-radio v-model="retirementReason"
                      label="結婚のため">結婚のため</el-radio>
            <el-radio v-model="retirementReason"
                      label="出産のため">出産のため</el-radio>
            <el-radio v-model="retirementReason"
                      label="家族の介護のため">家族の介護のため</el-radio>
            <el-radio v-model="retirementReason"
                      label="病気治療のため">病気治療のため</el-radio>
          </div>
        </div>
      </div>

    </div>
    <div class="text-right">
      <el-button type="primary"
                 @click="setJobHistories()">追加する</el-button>
      <el-button @click="$modal.hide('job-dialog');">閉じる</el-button>
      <div v-show="errorMessage">{{ errorMessage }}</div>
    </div>
    <div class="text-right">
      <br/>
      <br/>
    </div>
  </modal>
</div>
</template>

<script>
export default {
  props: {
    birthYear: {
      type: [Number, String]
    },
    birthMonth: {
      type: [Number, String]
    },
    birthDay: {
      type: [Number, String]
    }
  },
  data: function () {
    return {
      resetDialogVisible: false,
      company: {},
      isContinuing: false,
      jobHistories: [],
      errorMessage: '',
      retirementReason: ''
    }
  },
  computed: {
    calcMinYear: function () {
      if (this.birthYear) {
        return Number(this.birthYear) + 15
      } else {
        return 1900
      }
    },
    calcMaxYear: function () {
      return new Date().getFullYear() + 3
    }
  },
  methods: {
    setJobHistories: function () {
      let companyCount = 0
      this.jobHistories = []
      this.errorMessage = ''

      const c = this.company
      if (c.isEmpty()) {
        console.log('c.isEmpty', c.isEmpty(), c)
        return
      }
      companyCount++
      this.jobHistories.push({
        year: c.startYear,
        month: c.startMonth,
        desc: c.name + '　入社'
      })
      if (this.isContinuing) {
        this.jobHistories.push({
          year: '',
          month: '',
          desc: '現在に至る'
        })
      } else if (c.endYear) {
        this.jobHistories.push({
          year: c.endYear,
          month: c.endMonth,
          desc: c.name + '　' + this.retirementReason + '退社'
        })
      } else if (companyCount === 0) {
        this.errorMessage = '入力してください'
        console.log(this.company)
        return
      }
      this.$emit('job-histories-created', this.jobHistories)
      this.$modal.hide('job-dialog')
    },
    setCompany: function (name, startYear, startMonth, endYear, endMonth) {
      const CompanyItem = function (name, startYear, startMonth, endYear, endMonth) {
        this.name = name || ''
        this.startYear = startYear || ''
        this.startMonth = startMonth || ''
        this.endYear = endYear || ''
        this.endMonth = endMonth || ''
        this.isEmpty = function () {
          return !(this.name || this.startYear || this.startMonth || this.endYear || this.endMonth)
        }
      }
      // console.log('addCompany', name, startYear, startMonth, endYear, endMonth)
      const company = new CompanyItem(name, startYear, startMonth, endYear, endMonth)
      this.company = company
    },
    resetCompanies: function () {
      this.setCompany()
      this.isContinuing = false
    }
  },
  watch: {},
  mounted: function () {}
}
</script>
